module.exports = __webpack_public_path__ + "media/components/country-flag/static/my-1a8769669d0e5cfb8ce1f87ef6a78a89.svg";